var map = {
	"./abomination_large_2.png": 242,
	"./angel.png": 243,
	"./archer.png": 244,
	"./background.png": 245,
	"./birdy.png": 246,
	"./black_paper.png": 247,
	"./blink.png": 248,
	"./blue_fountain.png": 249,
	"./chain_mail_3.png": 102,
	"./cloud_black_smoke.png": 250,
	"./cloud_meph_2.png": 251,
	"./control_undead_new.png": 252,
	"./crab.png": 253,
	"./cyan_new.png": 41,
	"./daeva.png": 254,
	"./dark_blue_new.png": 255,
	"./draconic_base-black_new.png": 256,
	"./drink_two.png": 257,
	"./dwarf.png": 258,
	"./efreet.png": 259,
	"./erica.png": 260,
	"./error.png": 43,
	"./executioner.png": 261,
	"./fire_breath.png": 103,
	"./formicid.png": 262,
	"./francis.png": 263,
	"./fuchiass.png": 264,
	"./gem_brass_new.png": 265,
	"./ghost.png": 56,
	"./giant_amoeba_new.png": 266,
	"./golden_dragon.png": 267,
	"./heart.png": 100,
	"./hellbinder.png": 268,
	"./hellknight.png": 269,
	"./hobgoblin.png": 270,
	"./infernal.png": 271,
	"./kratos_on_acid.png": 272,
	"./large_shield_1_new.png": 273,
	"./lorocyproca_old.png": 274,
	"./merfolk.png": 275,
	"./misc_deck_legendary_new.png": 276,
	"./misc_lantern.png": 277,
	"./mutant_beast.png": 278,
	"./necromutation_old.png": 279,
	"./norbert.png": 280,
	"./obi.png": 281,
	"./orange_demon_new.png": 282,
	"./paladin.png": 283,
	"./plumson.png": 284,
	"./polymorph_other.png": 104,
	"./quicksilver_dragon_new.png": 285,
	"./reaper_new.png": 286,
	"./ru.png": 287,
	"./rune_abyss.png": 288,
	"./satyr.png": 289,
	"./scroll_yellow.png": 42,
	"./sensed_monster_nasty.png": 44,
	"./shadow_fiend_new.png": 290,
	"./shining_eye_new.png": 291,
	"./shining_one.png": 292,
	"./sigmund.png": 293,
	"./statue_ancient_evil.png": 294,
	"./treant.png": 295,
	"./ugly_thing.png": 296,
	"./unseen_item_old.png": 297,
	"./unseen_weapon_new.png": 45,
	"./urand_bloodlust_new.png": 101,
	"./vine_stalker.png": 298,
	"./water_nymph.png": 299,
	"./zot.png": 300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;